import { Accordion } from '../../../../../../common/SharedComponents';
import { ILoanHistorySummaryTableRow } from '../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { SBATable } from './components/SBATable';
import { ISBATableRow } from '../common/constants/tables/interfaces/ISBATableRow';
interface SBAProps {
    sbaData?: ISBATableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const SBA: React.FC<SBAProps> = ({ onLoanSummaryClick, sbaData }) => {
    return (
        <>
            <Accordion
                title='SBA'
                isExpanded={true}
                id={`bll_sba`}
                isCollapsable={true}
            >
                <div
                    className='card'
                    style={{ width: '600px', border: '1px solid gray' }}
                >
                    <div className='card-section'>
                        <SBATable
                            onLoanSummaryClick={onLoanSummaryClick}
                            sbaData={sbaData}
                        />
                    </div>
                </div>
            </Accordion>
        </>
    );
};
